// extracted by mini-css-extract-plugin
export default {"body":"VxX7Q1BCld26U1yEy3sO","backBtn":"mSZ8mQ1NjfA7cJPJnHgP"};